/* Start muted once the YouTube player is ready and the lesson is in view. */
(() => {
  function youtube() {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (window.TytoYouTubeReady) return window.TytoYouTubeReady;
    window.TytoYouTubeReady = new Promise((resolve, reject) => {
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => { previous?.(); resolve(window.YT); };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.onerror = () => { delete window.TytoYouTubeReady; script.remove(); reject(new Error('Video player unavailable')); };
        document.head.append(script);
      }
    });
    return window.TytoYouTubeReady;
  }
  if (!customElements.get('training-video')) customElements.define('training-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.button?.addEventListener('click', () => { this.manual = true; this.start(); this.sync(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        if (this.visible && !this.motion.matches) this.start();
        this.sync();
      }, {threshold: .25});
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => this.sync(), options);
    }
    async start() {
      if (this.mounting || this.player || !/^[\w-]{11}$/.test(this.dataset.videoId)) return;
      this.mounting = true;
      try {
        const YT = await youtube(); if (!this.isConnected) return;
        const host = document.createElement('div'); host.className = 'training-video__player'; this.append(host);
        this.player = new YT.Player(host, {
          host: 'https://www.youtube-nocookie.com', videoId: this.dataset.videoId,
          playerVars: {autoplay: 1, mute: 1, playsinline: 1, rel: 0, origin: location.origin},
          events: {
            onReady: event => {
              this.playerReady = true;
              const frame = event.target.getIframe();
              frame.title = 'How to enroll in the Flight Stand Training Course';
              frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
              this.sync();
            },
            onStateChange: event => { if (event.data === YT.PlayerState.PLAYING) this.button.hidden = true; }
          }
        });
      } catch { this.mounting = false; }
    }
    sync() {
      if (!this.playerReady) return;
      this.player.mute();
      if (this.visible && !document.hidden && (!this.motion.matches || this.manual)) this.player.playVideo();
      else this.player.pauseVideo();
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.controller?.abort(); this.player?.destroy();
      this.player = null; this.playerReady = false; this.ready = false; this.mounting = false;
    }
  });
})();
